<template>
  <div>
    <v-card-title class="text-break">
      <div class="subtitle-1">{{ $t('job_ads.schedule') }}</div>
      <v-spacer></v-spacer>
      <v-btn
        color="secondary"
        @click="clearDates"
        text
        :disabled="!model || (model && model.length < 2)"
        small
      >
        {{ $t('clear') }}
      </v-btn>
    </v-card-title>
    <v-card-text>
      {{ $t('job_ads.schedule_explained') }}
    </v-card-text>
    <v-card-text>
      <v-date-picker
        no-title
        show-week
        full-width
        range
        v-model="model"
        :scrollable="$vuetify.breakpoint.mdAndUp"
      ></v-date-picker>
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: 'JobAdDateRangeSelector',
  props: {
    value: {
      type: Array,
      default: () => null
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    clearDates() {
      this.model = null;
    }
  }
}
</script>
